import generator from 'redux/hor/module';
import fetchWithView from 'redux/utils/fetchWithView';

const {
  reducer,
  fetch,
} = generator({
  name: 'CookingTechniques',
  tableId: 50,
});

export const fetchList = fetchWithView(fetch, 'ts5c50cs9r354', {
  useLS: true,
});

export {
  getItem,
} from 'redux/hor/module/selectors';

export {
  getSelectData,
} from './selectors';

export default reducer;
